import { IApiSymbol } from './IApiSymbol';
import { IApiStreamBase } from './IApiStream';
import { IApiNode } from './IApiNode';
import { IApiSpreadProfile } from './IApiSpreadProfile';

export enum ApiMarkupType {
  Points = 'POINTS',
}

export interface IApiMarkup {
  askMarkup: number;
  bidMarkup: number;
  id: IApiSymbol['id'];
  name: IApiSymbol['name'];
  type: ApiMarkupType;
  spreadProfileName?: string;
  tobMinSpread?: number | null;
  tobMaxSpread?: number | null;
}

export interface IApiStreamAssignedToMarkup extends Omit<IApiStreamBase, 'markupProfile'> {
  nodeId: IApiNode['id'];
}

export interface IApiMarkupDetails extends IApiMarkup {
  streams?: IApiStreamAssignedToMarkup[];
  spreadProfile?: IApiSpreadProfile;
}

export interface IApiMarkupsList {
  symbolMarkups: IApiMarkup[];
  filteredCount: number;
  totalCount: number;
}

export interface IApiMarkupUpdate {
  askMarkup: number;
  bidMarkup: number;
  type: ApiMarkupType;
  spreadProfileId?: number | null;
}
